import React, { useState, useRef, useEffect } from "react";
import ButtonSpinner from "../components/Spinner/ButtonSpinner";
import { useNavigate, useLocation } from "react-router-dom";
import ExpandableTextMobile from "../components/ExpandableText";
import { BASE_MOBILE_API_URL, BASIC_AUTH } from "../constants";
import axios from "axios";
import { notifyError } from "../components/notify";
import { ToastContainer } from "react-toastify";

const Signup = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [nameError, setNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [mobileError, setMobileError] = useState("");
  const [passError, setPassError] = useState("");

  const selectedCompany = location.state?.company;

  const nameRef = useRef();

  useEffect(() => {
    if (nameRef.current) {
      nameRef.current.focus();
    }
  }, []);

  // If no company selected → redirect back
  // useEffect(() => {
  //   if (!selectedCompany) {
  //     navigate("/company-list");
  //   }
  // }, [selectedCompany, navigate]);

  // if (!selectedCompany) return null;

  // ================= VALIDATION =================
  const validateForm = () => {
    let valid = true;

    if (!name.trim()) {
      setNameError("Name is required");
      valid = false;
    } else setNameError("");

    if (email && !/\S+@\S+\.\S+/.test(email)) {
      setEmailError("Invalid email format");
      valid = false;
    } else setEmailError("");

    if (!mobile.trim()) {
      setMobileError("Mobile number is required");
      valid = false;
    } else if (!/^\d{10}$/.test(mobile)) {
      setMobileError("Mobile must be 10 digits");
      valid = false;
    } else setMobileError("");

    if (!password.trim()) {
      setPassError("Password is required");
      valid = false;
    } else setPassError("");

    return valid;
  };

  // ================= SUBMIT =================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;
    try {
      const response = await axios.post(
        `${BASE_MOBILE_API_URL}/customer_signup`,
        {
          companycode: selectedCompany?.companycode,
          branchcode: selectedCompany?.branchcode,
          name: name,
          mobile: mobile,
          email: email,
          password: password,
        },
        {
          headers: {
            Authorization: BASIC_AUTH,
            "Content-Type": "application/json",
          },
        },
      );

      if (response.status === 200) {
        navigate("/signin", { replace: true, state: { fromSignup: true } });
      }
    } catch (err) {
      if (err.response) {
        // Server responded with error status
        const errorMessage =
          err.response?.data && typeof err.response.data === "string"
            ? err.response.data
            : err.response?.data?.message ||
              err.response?.data?.error ||
              "Signup failed";

        notifyError(errorMessage);
      } else if (err.request) {
        // No response received
        notifyError("Server not responding. Please try again.");
      } else {
        // Other errors
        notifyError("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="container-fluid min-vh-100 d-flex align-items-center justify-content-center bg-black">
        <div className="row w-100 justify-content-center">
          <div className="col-lg-7 col-md-6 col-sm-10">
            <div className="shadow-sm rounded-4 bg-Modal-black">
              <div className="card-body px-3 py-3">
                {/* Back Button */}
                <div className="d-flex justify-content-end mb-2">
                  <button
                    type="button"
                    className="back-btn"
                    onClick={() =>
                      navigate("/signin", {
                        replace: true,
                        state: { fromSignup: true },
                      })
                    }
                  >
                    <i className="fa-solid fa-arrow-left me-2"></i> Back to Sign
                    In
                  </button>
                </div>

                {/* Header */}
                <div className="text-center mb-4">
                  <h4 className="fw-bold text-theme mb-0">
                    Create New Account
                  </h4>
                </div>
                {/* Selected Company Card */}
                {selectedCompany && (
                  <div className="company-selected-card mb-4 p-2 rounded-4 mx-lg-5">
                    {/* Centered Logo */}
                    <div className="company-logo-top">
                      <img
                        src={selectedCompany.company_image}
                        alt="company logo"
                      />
                    </div>

                    {/* Company Details (same old alignment) */}
                    <div className="company-details-signup">
                      <div className="detail-row">
                        <div className="company-label-signup">
                          Company Name :
                        </div>
                        <div className="company-value-signup">
                          {selectedCompany.company_name}
                        </div>
                      </div>

                      <div className="detail-row">
                        <div className="company-label-signup">
                          Company Address :
                        </div>
                        <ExpandableTextMobile
                          text={selectedCompany.company_address}
                          className="company-value-signup"
                        />
                      </div>

                      <div className="detail-row">
                        <div className="company-label-signup">
                          Branch Name :
                        </div>
                        <ExpandableTextMobile
                          text={selectedCompany.branchname}
                          className="company-value-signup"
                        />
                      </div>

                      <div className="detail-row">
                        <div className="company-label-signup">
                          Branch Address :
                        </div>
                        <ExpandableTextMobile
                          text={selectedCompany.branch_address}
                          className="company-value-signup"
                        />
                      </div>
                    </div>
                  </div>
                )}
                {/* Form */}
                <form
                  onSubmit={handleSubmit}
                  autoComplete="off"
                  className="px-2"
                >
                  <div className="col-12 d-md-flex d-lg-flex d-block justify-content-md-between ">
                    {/* Name */}
                    <div className="mb-3 col-md-5 col-lg-5 col-12 ms-md-3">
                      <label className="form-label small text-white fw-semibold">
                        Name <span className="red-error">*</span>
                      </label>
                      <input
                        ref={nameRef}
                        type="text"
                        className="form-control"
                        placeholder="Enter name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      {nameError && (
                        <p className="red-error m-0">{nameError}</p>
                      )}
                    </div>

                    {/* Mobile */}
                    <div className="mb-3 col-md-5 col-lg-5 col-12 me-md-3">
                      <label className="form-label small text-white fw-semibold">
                        Mobile No. <span className="red-error">*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Enter mobile number"
                        value={mobile}
                        onChange={(e) =>
                          setMobile(e.target.value.replace(/\D/g, ""))
                        }
                        maxLength={10}
                      />
                      {mobileError && (
                        <p className="red-error m-0">{mobileError}</p>
                      )}
                    </div>
                  </div>
                  <div className="col-12 d-md-flex d-lg-flex d-block justify-content-md-between ">
                    {/* Email */}
                    <div className="mb-3 col-md-5 col-lg-5 col-12 ms-md-3">
                      <label className="form-label small text-white fw-semibold">
                        Email
                      </label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {emailError && (
                        <p className="red-error m-0">{emailError}</p>
                      )}
                    </div>
                    <div className="mb-2 text-white position-relative col-md-5 col-lg-5 col-12 me-md-3">
                      <label className="form-label small fw-semibold">
                        Password <span className="red-error">*</span>
                      </label>

                      <div className="position-relative">
                        <input
                          type={showPassword ? "text" : "password"}
                          className="form-control pe-5"
                          placeholder="Enter password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                        />

                        <button
                          type="button"
                          className="password_eye_container"
                          onClick={() => setShowPassword((prev) => !prev)}
                        >
                          <span className="material-icons">
                            {showPassword ? "visibility_off" : "visibility"}
                          </span>
                        </button>
                      </div>

                      {passError && (
                        <p className="red-error m-0">{passError}</p>
                      )}
                    </div>
                  </div>

                  {/* Submit */}
                  <div className="d-flex justify-content-center align-items-center mb-3 mt-4">
                    <ButtonSpinner
                      type="submit"
                      className="col-md-5 col-9 btn-theme bg-gradient-info btn-md"
                      loading={loading}
                    >
                      <b>{loading ? "Creating..." : "Create Account"}</b>
                    </ButtonSpinner>
                  </div>
                </form>

                {/* Footer */}
                <div className="text-center mt-4">
                  <small className="text-white">© 2026 NPRO</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default Signup;
